import React, { Component } from 'react';
import { Button } from 'antd';
export default class Filterfooter extends Component {
    handleCancel = () => {
        this.props.onNameErrInfoChange('');
        this.props.onContextErrInfoChange('');
        this.props.onEnuErrInfoChange('');
        this.props.onCodeIdErrInfoChange('');
        this.props.onStylecodeErrInfoChange('');
        this.props.onReturnErrInfoChang('');
        this.props.oncompareErrInfoChange('');
        this.props.onfilterErrIfoChange('');
        this.props.handleclose();
        return
    }
    handleCheck = () => {
        this.props.checkitem();
    }
    handleOk = () => {
        this.props.onNameErrInfoChange('')
        this.props.onContextErrInfoChange('')
        this.props.onEnuErrInfoChange('')
        this.props.onCodeIdErrInfoChange('')
        this.props.onStylecodeErrInfoChange('')
        this.props.onReturnErrInfoChang('')
        this.props.oncompareErrInfoChange('')
        this.props.onfilterErrIfoChange('')
        const { operatorValue, filterName, enuchangevalue, codeId, selectvalue, selectfilter, defaultrefer,styleCodeId } = this.props
        if (filterName == ''|| filterName == undefined || operatorValue == ''|| operatorValue == undefined || selectvalue == '' || selectvalue == undefined || selectfilter == '' || selectfilter == undefined || selectfilter == 'Select' || selectfilter == 'Refer') {
            if (filterName == '' || filterName == undefined) {
                this.props.onNameErrInfoChange('不能为空')
            }
            if (operatorValue == '' || operatorValue == undefined) {
                this.props.onContextErrInfoChange('不能为空')
            }
            if (selectvalue == '' || selectvalue == undefined) {
                this.props.oncompareErrInfoChange('不能为空')
            }
            if (selectfilter == '' || selectfilter == undefined) {
                this.props.onfilterErrIfoChange('不能为空')
            }
            // if (selectfilter == 'DatePicker') {
            //     if (filterName != '' && filterName != undefined && operatorValue != '' && operatorValue != undefined && selectvalue != '' && selectvalue != undefined) {
            //         this.props.onsave();
            //     }
            // }
            if (selectfilter == 'Select') {
                if (enuchangevalue == '' || enuchangevalue == undefined) {
                    this.props.onEnuErrInfoChange('不能为空')
                }
                if (enuchangevalue != '' && enuchangevalue != undefined && filterName != '' && filterName != undefined && operatorValue != '' && operatorValue != undefined && selectvalue != '' && selectvalue != undefined) {
                    this.props.onsave();
                }
            }
            // if (selectfilter == 'Input') {
            //     if (filterName != '' && filterName != undefined && operatorValue != '' && operatorValue != undefined && selectvalue != '' && selectvalue != undefined) {
            //         this.props.onsave();
            //     }
            // }
            if (selectfilter == 'Refer') {
                if (codeId == '' || codeId == null) {
                    this.props.onCodeIdErrInfoChange('不能为空')
                }
                if (defaultrefer == '' || defaultrefer == undefined) {
                    this.props.onReturnErrInfoChang('不能为空')
                }
                // if(codeId.indexOf("pc_userdefclassref")!=-1){
                //     if(styleCodeId == '' || styleCodeId==null){
                //         this.props.onStylecodeErrInfoChange('不能为空')
                //     }
                // }
                // if (codeId != '' && codeId != undefined && defaultrefer != '' && defaultrefer != undefined && filterName != '' && filterName != undefined && operatorValue != '' && operatorValue != undefined && selectvalue != '' && selectvalue != undefined && styleCodeId != '' && styleCodeId != undefined) {
                //     this.props.onsave();
                // }
                if (codeId != '' && codeId != undefined && filterName != '' && filterName != undefined && operatorValue != '' && operatorValue != undefined && selectvalue != '' && selectvalue != undefined) {
                  if(codeId.indexOf("pc_userdefclassref")!=-1){
                      if(styleCodeId == '' || styleCodeId==null){
                          this.props.onStylecodeErrInfoChange('不能为空')
                      }
                      else if(defaultrefer != '' && defaultrefer != undefined ){
                          this.props.onsave();
                      }
                  }
                  else if(defaultrefer != '' && defaultrefer != undefined ){
                      this.props.onsave();
                  }

              }
            }
            // if (selectfilter == 'inputnumber') {
            //     if (filterName != '' && filterName != undefined && operatorValue != '' && operatorValue != undefined && selectvalue != '' && selectvalue != undefined) {
            //         this.props.onsave();
            //     }
            // }
            return
        }
        this.props.onsave();
    }
    render() {
        const checkPass = this.props.checkPass;
        const checkState = this.props.checkState;
        return (
            <div>
                <Button onClick={this.handleCancel}>取消</Button>
                <Button disabled={!checkState} onClick={this.handleCheck}>校验</Button>
                <Button disabled={!checkPass} onClick={this.handleOk}>确定</Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/filter/filterfooter.jsx